import React from 'react';
import { Modal } from 'semantic-ui-react';

export interface CmModalProps {
  open: boolean;
  onClose: () => void;
  title: React.ReactNode;
  size?: 'mini' | 'tiny' | 'small' | 'large' | 'fullscreen';
  children: React.ReactNode;
  closeIcon?: boolean;
  testId?: string;
}

export function CmModal({
  open,
  onClose,
  title,
  size = 'small',
  children,
  closeIcon = true,
  testId,
}: CmModalProps): React.ReactElement {
  return (
    <Modal
      open={open}
      onClose={onClose}
      size={size}
      dimmer="inverted"
      closeIcon={closeIcon}
      data-testid={testId}
    >
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>{children}</Modal.Content>
    </Modal>
  );
}

export default CmModal;
